import styled, {createGlobalStyle} from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  html,
  body {
      background-color: #fff;
  }
  * {
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      
      &,
      ::before,
      ::after {
          box-sizing: border-box;
      }
  }
  img {
      max-width: 100%;
      display: block;
  }
  em {
      font-style: normal;
  }

  body {
    overflow: hidden;
  }
`

export const FullSizeInContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Page = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const Container169 = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  will-change: auto;
  backface-visibility: hidden;

  & > div {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
